@if (mode === 'renderer') {
  <div
    class="dc-card d-flex {{ element.fields.displayHorizontal }} {{ element.fields.displayVertical }}"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor,
      '--min-height': (element.fields.minHeight || 0) + 'px',
      '--tablet-min-height': (element.fields.tabletMinHeight || element.fields.minHeight || 0) + 'px',
      '--mobile-min-height': (element.fields.mobileMinHeight || element.fields.tabletMinHeight || element.fields.minHeight || 0) + 'px',
      'background-image': element.fields.backgroundImage ? 'url(' + element.fields.backgroundImage + ')' : null
    }"
  >
    <div
      class="card-content"
      [ngStyle]="{ 'max-width.px': element.fields.contentMaxWidth ? element.fields.contentMaxWidth : null }"
    >
      <div
        [innerHTML]="
          (element.fields.translate
            ? element.fields.title.i18n?.[currentLang]
            : element.fields.title.value || element.fields.title.value === ''
              ? element.fields.title.value
              : element.fields.title) | safeHtml
        "
      ></div>
      <div
        [innerHTML]="
          (element.fields.translate
            ? element.fields.description.i18n?.[currentLang]
            : element.fields.description.value || element.fields.description.value === ''
              ? element.fields.description.value
              : element.fields.description) | safeHtml
        "
      ></div>
      <div class="card-dp-buttons" [ngClass]="element.fields.buttonGroupAlignment">
        <div
          (click)="btnClick($event, element.fields.button1Link)"
          class="card-dp-btn"
          [ngStyle]="{
            color: element.fields.button1Color,
            'font-size.px': element.fields.button1FontSize,
            'background-color': element.fields.button1Background,
            'margin-top.px': element.fields.button1MarginTop,
            'margin-right.px': element.fields.button1MarginRight,
            'margin-bottom.px': element.fields.button1MarginBottom,
            'margin-left.px': element.fields.button1MarginLeft,
            'padding-top.px': element.fields.button1PaddingTop,
            'padding-right.px': element.fields.button1PaddingRight,
            'padding-bottom.px': element.fields.button1PaddingBottom,
            'padding-left.px': element.fields.button1PaddingLeft,
            'text-align': element.fields.button1Align,
            'width.px': element.fields.button1Width
          }"
        >
          <span class="d-inline-block w-100">
            @if (element.fields.translate) {
              {{ element.fields.button1Text.i18n?.[currentLang] }}
            } @else {
              @if (element.fields.button1Text.value) {
                {{ element.fields.button1Text.value }}
              } @else {
                {{ element.fields.button1Text }}
              }
            }
          </span>
        </div>
        @if (element.fields.button2Enable) {
          <div
            class="card-dp-btn"
            (click)="btnClick($event, element.fields.button2Link)"
            [ngStyle]="{
              color: element.fields.button2Color,
              'font-size.px': element.fields.button2FontSize,
              'background-color': element.fields.button2Background,
              'margin-top.px': element.fields.button2MarginTop,
              'margin-right.px': element.fields.button2MarginRight,
              'margin-bottom.px': element.fields.button2MarginBottom,
              'margin-left.px': element.fields.button2MarginLeft,
              'padding-top.px': element.fields.button2PaddingTop,
              'padding-right.px': element.fields.button2PaddingRight,
              'padding-bottom.px': element.fields.button2PaddingBottom,
              'padding-left.px': element.fields.button2PaddingLeft,
              'text-align': element.fields.button2Align,
              'width.px': element.fields.button2Width
            }"
          >
            <span class="d-inline-block w-100">
              @if (element.fields.translate) {
                {{ element.fields.button2Text.i18n?.[currentLang] }}
              } @else {
                @if (element.fields.button2Text.value) {
                  {{ element.fields.button2Text.value }}
                } @else {
                  {{ element.fields.button2Text }}
                }
              }
            </span>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.translate"
                  id="translate"
                  (ngModelChange)="changeTranslate()"
                />
                <label class="form-check-label" for="translate">Translate</label>
              </div>
            </div>
            @if (element.fields.translate) {
              <lib-gung-accordion [closeOthers]="false">
                @for (lang of translateLangs; track lang) {
                  <lib-gung-accordion-item [collapsed]="true">
                    <ng-template libGungAccordionHeader>{{ lang.toUpperCase() }}</ng-template>
                    <ng-template libGungAccordionBody class="acc-body">
                      <div class="col-12 mb-2">
                        <lib-gung-html-editor
                          [gungTranslate]="'TITLE'"
                          [angularEditorConfig]="angularEditorConfig"
                          placeholder="Type the content here!"
                          [(ngModel)]="element.fields.title.i18n[lang]"
                          [backgroundColor]="element.fields.backgroundColor"
                        ></lib-gung-html-editor>
                      </div>
                      <div class="col-12 mb-2">
                        <lib-gung-html-editor
                          [gungTranslate]="'DESCRIPTION'"
                          [angularEditorConfig]="angularEditorConfig"
                          placeholder="Type the content here!"
                          [(ngModel)]="element.fields.description.i18n[lang]"
                          [backgroundColor]="element.fields.backgroundColor"
                        ></lib-gung-html-editor>
                      </div>
                      <div class="col-12 mb-2">
                        <lib-gung-text-input
                          [gungTranslate]="'Button 1'"
                          [(ngModel)]="element.fields.button1Text.i18n[lang]"
                        ></lib-gung-text-input>
                      </div>
                      @if (element.fields.button2Enable) {
                        <div class="col-12 mb-2">
                          <lib-gung-text-input
                            [gungTranslate]="'Button 2'"
                            [(ngModel)]="element.fields.button2Text.i18n[lang]"
                          ></lib-gung-text-input>
                        </div>
                      }
                    </ng-template>
                  </lib-gung-accordion-item>
                }
              </lib-gung-accordion>
            } @else {
              <div class="col-12 mb-2">
                @if (element.fields.title.value || element.fields.title.value === '') {
                  <lib-gung-html-editor
                    [gungTranslate]="'TITLE'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.title.value"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                } @else {
                  <lib-gung-html-editor
                    [gungTranslate]="'TITLE'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.title"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                }
              </div>
              <div class="col-12 mb-2">
                @if (element.fields.description.value || element.fields.description.value === '') {
                  <lib-gung-html-editor
                    [gungTranslate]="'DESCRIPTION'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.description.value"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                } @else {
                  <lib-gung-html-editor
                    [gungTranslate]="'DESCRIPTION'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.description"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                }
              </div>
            }

            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="form-group">
                  <label [for]="idUploadInput">Background Image</label>
                  <input
                    type="text"
                    class="form-control"
                    id="{{ idUploadInput }}"
                    [(ngModel)]="element.fields.backgroundImage"
                  />
                </div>

                <!-- <lib-gung-text-input
                  [gungTranslate]="'Background Image'"
                  [(ngModel)]="element.fields.backgroundImage"
                  inputId=""
                ></lib-gung-text-input> -->
                <div (click)="uploadImage()" class="cursor-pointer upload-image">
                  <i class="fa-solid fa-upload"></i>
                </div>
              </div>
            </div>
            @if (!element.fields.translate) {
              <div class="col-12 mb-2">
                @if (element.fields.button1Text.value) {
                  <lib-gung-text-input
                    [gungTranslate]="'Button 1'"
                    [(ngModel)]="element.fields.button1Text.value"
                  ></lib-gung-text-input>
                } @else {
                  <lib-gung-text-input
                    [gungTranslate]="'Button 1'"
                    [(ngModel)]="element.fields.button1Text"
                  ></lib-gung-text-input>
                }
              </div>
            }
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Button 1 link'"
                [(ngModel)]="element.fields.button1Link"
              ></lib-gung-text-input>
            </div>
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.button2Enable"
                  id="button2Enable"
                />
                <label class="form-check-label" for="button2Enable">Active Button 2</label>
              </div>
            </div>
            @if (element.fields.button2Enable) {
              @if (!element.fields.translate) {
                <div class="col-12 mb-2">
                  @if (element.fields.button2Text.value) {
                    <lib-gung-text-input
                      [gungTranslate]="'Button 2'"
                      [(ngModel)]="element.fields.button2Text.value"
                    ></lib-gung-text-input>
                  } @else {
                    <lib-gung-text-input
                      [gungTranslate]="'Button 2'"
                      [(ngModel)]="element.fields.button2Text"
                    ></lib-gung-text-input>
                  }
                </div>
              }
              <div class="col-12 mb-2">
                <lib-gung-text-input
                  [gungTranslate]="'Button 2 link'"
                  [(ngModel)]="element.fields.button2Link"
                ></lib-gung-text-input>
              </div>
            }
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <lib-gung-accordion #acc="gungAccordion" [closeOthers]="false">
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>General Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <lib-dynamic-page-element-margin-padding
                    [(marginTop)]="element.fields.marginTop"
                    [(marginRight)]="element.fields.marginRight"
                    [(marginBottom)]="element.fields.marginBottom"
                    [(marginLeft)]="element.fields.marginLeft"
                    [(paddingTop)]="element.fields.paddingTop"
                    [(paddingRight)]="element.fields.paddingRight"
                    [(paddingBottom)]="element.fields.paddingBottom"
                    [(paddingLeft)]="element.fields.paddingLeft"
                  ></lib-dynamic-page-element-margin-padding>

                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'MIN_HEIGHT'"
                      [(ngModel)]="element.fields.minHeight"
                    ></lib-gung-number-input>
                  </div>
                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'MIN_HEIGHT_TABLET_PX'"
                      [(ngModel)]="element.fields.tabletMinHeight"
                    ></lib-gung-number-input>
                  </div>
                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'MIN_HEIGHT_MOBILE_PX'"
                      [(ngModel)]="element.fields.mobileMinHeight"
                    ></lib-gung-number-input>
                  </div>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.backgroundColor"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
                    </div>
                  </div>
                  <div class="col-12">
                    <lib-gung-select-option-input
                      gungTranslate="Content Position Vertical"
                      [optionsList]="verticalOptions"
                      [(ngModel)]="element.fields.displayVertical"
                    ></lib-gung-select-option-input>
                  </div>
                  <div class="col-12">
                    <lib-gung-select-option-input
                      gungTranslate="Content Position Horizontal"
                      [optionsList]="horizontalOptions"
                      [(ngModel)]="element.fields.displayHorizontal"
                    ></lib-gung-select-option-input>
                  </div>
                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'Content Max Width'"
                      [(ngModel)]="element.fields.contentMaxWidth"
                    ></lib-gung-number-input>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
            <!--<lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>Title Settings</ng-template>
              <ng-template libGungAccordionBody>
                <lib-dynamic-page-general-field-styles
                  [(fontSize)]="element.fields.titleFontSize"
                  [(color)]="element.fields.titleColor"
                  [(align)]="element.fields.titleAlign"
                ></lib-dynamic-page-general-field-styles>
              </ng-template>
            </lib-gung-accordion-item>
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>Description Settings</ng-template>
              <ng-template libGungAccordionBody>
                <lib-dynamic-page-general-field-styles
                  [(fontSize)]="element.fields.descriptionFontSize"
                  [(color)]="element.fields.descriptionColor"
                  [(align)]="element.fields.descriptionAlign"
                ></lib-dynamic-page-general-field-styles>
              </ng-template>
            </lib-gung-accordion-item>-->
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>Button Group Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="d-flex mt-2">
                  <button
                    class="btn btn-sm btn-outline-secondary"
                    [class.active]="element.fields.buttonGroupAlignment === 'justify-content-start'"
                    (click)="element.fields.buttonGroupAlignment = 'justify-content-start'"
                  >
                    <i class="fa-solid fa-align-left"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary"
                    [class.active]="element.fields.buttonGroupAlignment === 'justify-content-center'"
                    (click)="element.fields.buttonGroupAlignment = 'justify-content-center'"
                  >
                    <i class="fa-solid fa-align-center"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary"
                    [class.active]="element.fields.buttonGroupAlignment === 'justify-content-end'"
                    (click)="element.fields.buttonGroupAlignment = 'justify-content-end'"
                  >
                    <i class="fa-solid fa-align-right"></i>
                  </button>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>Button 1 Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'Width'"
                      [(ngModel)]="element.fields.button1Width"
                    ></lib-gung-number-input>
                  </div>
                  <div class="col-12">
                    <lib-dynamic-page-general-field-styles
                      [(fontSize)]="element.fields.button1FontSize"
                      [(color)]="element.fields.button1Color"
                      [(align)]="element.fields.button1Align"
                    ></lib-dynamic-page-general-field-styles>
                  </div>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.button1Background"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.button1Background" />
                    </div>
                  </div>
                  <div class="col-12">
                    <lib-dynamic-page-element-margin-padding
                      [(marginTop)]="element.fields.button1MarginTop"
                      [(marginRight)]="element.fields.button1MarginRight"
                      [(marginBottom)]="element.fields.button1MarginBottom"
                      [(marginLeft)]="element.fields.button1MarginLeft"
                      [(paddingTop)]="element.fields.button1PaddingTop"
                      [(paddingRight)]="element.fields.button1PaddingRight"
                      [(paddingBottom)]="element.fields.button1PaddingBottom"
                      [(paddingLeft)]="element.fields.button1PaddingLeft"
                    ></lib-dynamic-page-element-margin-padding>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>Button 2 Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'Width'"
                      [(ngModel)]="element.fields.button2Width"
                    ></lib-gung-number-input>
                  </div>
                  <div class="col-12">
                    <lib-dynamic-page-general-field-styles
                      [(fontSize)]="element.fields.button1FontSize"
                      [(color)]="element.fields.button2Color"
                      [(align)]="element.fields.button2Align"
                    ></lib-dynamic-page-general-field-styles>
                  </div>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.button2Background"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.button2Background" />
                    </div>
                  </div>
                  <div class="col-12">
                    <lib-dynamic-page-element-margin-padding
                      [(marginTop)]="element.fields.button2MarginTop"
                      [(marginRight)]="element.fields.button2MarginRight"
                      [(marginBottom)]="element.fields.button2MarginBottom"
                      [(marginLeft)]="element.fields.button2MarginLeft"
                      [(paddingTop)]="element.fields.button2PaddingTop"
                      [(paddingRight)]="element.fields.button2PaddingRight"
                      [(paddingBottom)]="element.fields.button2PaddingBottom"
                      [(paddingLeft)]="element.fields.button2PaddingLeft"
                    ></lib-dynamic-page-element-margin-padding>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="card-info-preview">
    <div class="cip-title">Title</div>
    <div class="cip-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
    <div class="cip-btns">
      <div class="cip-btn">link 1</div>
      <div class="cip-btn">link 2</div>
    </div>
  </div>
}
